import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";

const CARD_SELECTOR = ".cardSlider";

export default class CarouselLandingPageElements extends DomElementsBase {
	constructor($module) {
		const selectors = [CARD_SELECTOR];

		super($module, selectors);
	}

	sliderElements() {
		return this.getElements(CARD_SELECTOR);
	}
}
